import React, { Component } from "react";
import FlexView from "react-flexview";
import moment from "moment";
import * as R from "ramda";

import SimpleDDL from "../../../../modules/SimpleDDL";
import SimpleDate from "../../../../modules/SimpleDate";
import SimpleInput from "../../../../modules/SimpleInput";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import { FJB_SEARCH_OPTIONS } from "../constant";

class FakturJualBengkelSearch extends Component {
  constructor(props) {
    super(props);
    this.isDGI = props.tab === "DGI";
    this.fieldAwal = this.isDGI ? "startPeriod" : "startTanggalFJB";
    this.fieldAkhir = this.isDGI ? "endPeriod" : "endTanggalFJB";
  }

  getDataValue = (fieldName) => {
    const { state } = this.props;
    return R.pathOr(null, ["searchData", fieldName], state);
  };

  handleDateChange = (field, value) => {
    this.props.onValueChange(field, moment(value).format("DD-MM-YYYY"));
  };

  renderCabangSelector() {
    const { state, onCabangChange, onManualGetDGIData, tab } = this.props;

    return (
      <FlexView vAlignContent="center" style={{ gap: 10 }}>
        <SimpleDDL
          id="select_options_nama_cabang"
          box="search"
          name={this.isDGI ? "mainDealer" : "kodeCabang"}
          containerclassname="width width-350px"
          placeholder={this.isDGI ? "Main Dealer" : "Nama cabang"}
          options={this.isDGI ? state.mdOptions : state.cabangOptions}
          value={this.isDGI ? state.mainDealer : state.kodeCabang}
          onChange={(value, { name }) => onCabangChange(name, value)}
        />
        {tab === "DGI" && (
          <SimpleButton
            onClick={onManualGetDGIData}
            className="btn background-red margin-bottom-15px"
            text="DGI Manual"
          />
        )}
      </FlexView>
    );
  }

  renderNosFilter() {
    const { state, onChangeNamCustomerOrNoPolisi, onSearchKeyword, tab } = this.props;
    const { searchData } = state;

    if (tab !== "NOS") return null;

    return (
      <React.Fragment>
        <SimpleDDL
          id="select_options_code_name_varian"
          placeholder="Nama Customer / No Polisi"
          box="search"
          containerclassname="width width-250px"
          isClearable
          options={FJB_SEARCH_OPTIONS}
          value={searchData?.dropdownType || null}
          onChange={(value) => {
            if(!value?.value){
              onChangeNamCustomerOrNoPolisi("keyword", null)
            }
            onChangeNamCustomerOrNoPolisi("dropdownType", value)
          }}
        />
        <SimpleInput
          placeholder="Nama Customer / No Polisi"
          readOnly={!searchData?.dropdownType}
          value={searchData?.keyword}
          onChange={({ target }) => onChangeNamCustomerOrNoPolisi("keyword", target.value)}
        />
        <SimpleButton
          text="Cari"
          disabled={!searchData?.keyword}
          secondary={!searchData?.keyword}
          className="margin-bottom-15px"
          onClick={()=>onSearchKeyword()}
          styles={{width: "unset"}}
        />
      </React.Fragment>
    );
  }

  render() {
    const { onShowFilter } = this.props;

    return (
      <FlexView column vAlignContent="center">
        {this.renderCabangSelector()}
        <FlexView
          style={{ justifyContent: "space-between" }}
          vAlignContent="center"
        >
          <FlexView vAlignContent="center" style={{ gap: 10 }}>
            <p className="margin-bottom-20px">Periode</p>
            <SimpleDate
              id="select_date_startTanggalFJB"
              name={this.fieldAwal}
              nextdate
              date={this.getDataValue(this.fieldAwal)}
              maxDate={this.getDataValue(this.fieldAkhir)}
              onChange={(value) => this.handleDateChange(this.fieldAwal, value)}
            />
            <SimpleDate
              id="select_date_startTanggalFJB"
              name={this.fieldAkhir}
              backdate
              date={this.getDataValue(this.fieldAkhir)}
              minDate={this.getDataValue(this.fieldAwal)}
              onChange={(value) =>
                this.handleDateChange(this.fieldAkhir, value)
              }
            />
            <SimpleButton
              text="Cari"
              className="margin-bottom-15px"
              onClick={this.props.onSubmit}
              styles={{width: "unset"}}
            />
          </FlexView>
          <FlexView vAlignContent="center" style={{ gap: 10 }}>
            {this.renderNosFilter()}
            <SimpleButton
              category="action_button"
              onClick={onShowFilter}
              className="btn background-red margin-bottom-15px"
              icon={
                <span>
                  <i className="fa fa-qrcode" />
                </span>
              }
            />
          </FlexView>
        </FlexView>
      </FlexView>
    );
  }
}

export default FakturJualBengkelSearch;
